import {
  ContentUserRole,
  ContentUserRoleDefinition,
  UserProfile,
  UserRoles,
  UserType,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { Route } from 'react-router-dom';
import UnAuthorized from './UnAuthorized';

const renderPrivateRoute = (
  // @ts-expect-error TS7006 - strict migration
  children,
  userProfile: UserProfile,
  allowedRoles: UserRoles[] = [],
  allowedContentRoles?: ContentUserRole[],
) => {
  // @ts-expect-error TS2769 - strict migration
  return Array.from(userProfile.roles).some((r) => allowedRoles.includes(r)) ||
    (allowedContentRoles &&
      // @ts-expect-error TS18048 - strict migration
      userProfile.contentRoles.some((r) => allowedContentRoles.includes(r.contentRole))) ? (
    children
  ) : (
    <UnAuthorized />
  );
};

// @ts-expect-error TS7006 - strict migration
const renderAWSRoute = (children, userProfile: UserProfile) => {
  return userProfile.type === UserType.AWS ? children : <UnAuthorized />;
};

// @ts-expect-error TS7031 - strict migration
export const AWSUserRoute = ({ children, userProfile, ...rest }) => {
  return <Route {...rest} exact render={(props) => renderAWSRoute(children, userProfile)} />;
};

// @ts-expect-error TS7031 - strict migration
export const AdminRoute = ({ children, userProfile, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => renderPrivateRoute(children, userProfile, [UserRoles.Admin])}
    />
  );
};

// @ts-expect-error TS7031 - strict migration
export const TechwriterRoute = ({ children, userProfile, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        renderPrivateRoute(children, userProfile, [UserRoles.Admin, UserRoles.TechWriter])
      }
    />
  );
};

// @ts-expect-error TS7031 - strict migration
export const PublisherRoute = ({ children, userProfile, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        renderPrivateRoute(
          children,
          userProfile,
          [UserRoles.Admin, UserRoles.TechWriter, UserRoles.Publisher],
          [ContentUserRole.BarRaiser],
        )
      }
    />
  );
};

// @ts-expect-error TS7031 - strict migration
export const BarRaiserRoute = ({ children, userProfile, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        renderPrivateRoute(children, userProfile, [UserRoles.Admin], [ContentUserRole.BarRaiser])
      }
    />
  );
};

// @ts-expect-error TS7031 - strict migration
export const ReviewerRoute = ({ children, userProfile, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        renderPrivateRoute(children, userProfile, [UserRoles.Admin, UserRoles.TechWriter])
      }
    />
  );
};
